import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HomeVideoService {
  openModal: boolean = false;


  @Output()
  scrollHidden: EventEmitter<boolean> = new EventEmitter();

  @Output()
  update: EventEmitter<boolean> = new EventEmitter();

  constructor() { }

  setScrollHidden(isHidden) {
    this.scrollHidden.emit(isHidden);
  }

  toggle() {
    this.openModal = !this.openModal;
    this.setScrollHidden(this.openModal);
    this.update.emit(this.openModal);
  }
}
